export const CALENDLY_URL = "https://calendly.com/ranjini-sutraadvisors/30min";
export const EMAIL = "ranjini@sutraadvisors.com";
export const EMAILS = ["ranjini@sutraadvisors.com", "madhurya@sutraadvisors.com"];
export const WHATSAPP_NUMBER = "917829237137";
export const whatsappUrl = (msg) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1686100511314-7d4a52987f2f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBjb3Jwb3JhdGUlMjBvZmZpY2UlMjBmaW5hbmNlfGVufDB8fHx8MTc4NjYwNjY0OHww&ixlib=rb-4.1.0&q=85",
  manufacturing: "https://images.unsplash.com/photo-1771530789155-b1f03fbf82b5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxtYW51ZmFjdHVyaW5nJTIwZmFjaWxpdHklMjBtb2Rlcm4lMjBjbGVhbnxlbnwwfHx8fDE3ODY2MDY2NDd8MA&ixlib=rb-4.1.0&q=85",
  founders: "https://images.unsplash.com/photo-1706565029882-b24b99930c94?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdCUyMGRpdmVyc2UlMjBmb3VuZGVyc3xlbnwwfHx8fDE3ODY2MDY2NDh8MA&ixlib=rb-4.1.0&q=85",
  chart: "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMGZpbmFuY2lhbCUyMGRhdGElMjBjaGFydHxlbnwwfHx8fDE3ODY2MDY2NDh8MA&ixlib=rb-4.1.0&q=85",
};

export const TICKER_ROWS = [
  ["Bookkeeping", "Monthly Close", "GST & Compliance", "Payroll", "Accounts Receivable", "Accounts Payable"],
  ["Part-Time CFO", "Cash Flow Forecasting", "Annual Operating Plan", "Board Reporting", "KPI Design & Reporting", "Financial Planning"],
  ["Investor-Ready Financials", "M&A Support", "Data Room Preparation", "Financial Modelling", "On-Demand Finance Talent", "Fractional CFO"],
];

export const SERVICES = [
  {
    num: "01",
    slug: "finance-operations",
    title: "Finance Operations",
    headline: ["Finance", "Operations."],
    sub: "The day-to-day finance function — bookkeeping, compliance, AR, AP and reporting — run as a managed service. Clean books by the 5th, every month, without you thinking about it.",
    desc: "The day-to-day finance function — bookkeeping, compliance, AR, AP and reporting — run as a managed service.",
    pills: ["Bookkeeping", "Monthly Close", "KPIs", "GST & TDS", "AR / AP"],
    allPills: ["Bookkeeping", "Monthly Close & Reporting", "KPI Design & Tracking", "Accounts Receivable", "Accounts Payable", "GST, TDS & Compliance"],
    services: [
      { name: "Bookkeeping", desc: "Full-stack general ledger, bank reconciliations, AR/AP posting and month-end journals — kept clean, current and audit-ready." },
      { name: "Monthly Close & Reporting", desc: "P&L, balance sheet and cash flow with written commentary, delivered by the 5th of every month. No chasing, no surprises." },
      { name: "KPIs — Design, Tracking & Reporting", desc: "A KPI framework built around your business model, a monthly dashboard, and benchmarks that tell you what good looks like." },
      { name: "Accounts Receivable Management", desc: "AR aging, automated follow-ups and collection forecasting — so revenue on paper becomes cash in the bank." },
      { name: "Accounts Payable & Vendor Management", desc: "Approval workflows, scheduled payment runs and vendor reconciliation. Every rupee out, accounted for." },
      { name: "GST, TDS & Statutory Compliance", desc: "All returns filed on time, every time. A compliance calendar you never have to think about again." },
    ],
  },
  {
    num: "02",
    slug: "cfo-advisory",
    title: "CFO Services",
    headline: ["CFO", "Services."],
    sub: "Strategic finance leadership on a part-time retainer. A CFO who knows your business, reads your numbers, and shows up every month — without the full-time cost.",
    desc: "Strategic finance leadership on a part-time retainer. Planning, forecasting, board reporting and CFO-level thinking.",
    pills: ["Part-Time CFO", "Budgeting", "Cash Flow", "Board Reporting"],
    allPills: ["Part-Time CFO", "Financial Planning & Budgeting", "Cash Flow Forecasting", "Board & Investor Reporting", "KPI Design & Tracking"],
    services: [
      { name: "Part-Time CFO", desc: "4–15 days a month of senior finance leadership — strategic oversight, investor and board liaison, and a steady hand on every big decision." },
      { name: "Financial Planning & Budgeting", desc: "Annual operating plans, quarterly reforecasts and monthly plan-vs-actual reviews that keep the whole team honest." },
      { name: "Cash Flow Management & Forecasting", desc: "A 13-week rolling cash forecast with amber flags on crunch weeks and a clear runway number you can trust." },
      { name: "Board & Investor Reporting", desc: "Board packs, investor updates and a financial narrative that makes your numbers tell the right story." },
      { name: "Annual Operating Plan & KPI Design", desc: "KPIs designed around your business model, targets your team can rally behind, and OKR alignment across functions." },
    ],
  },
  {
    num: "03",
    slug: "transactions",
    title: "Capital & Transactions",
    headline: ["Capital &", "Transactions."],
    sub: "From investor-ready financials to M&A due diligence to fundraising support — we help founder-run businesses access capital and close transactions without the process stalling on finance.",
    desc: "Fundraising support, M&A due diligence, investor-ready financials and data room preparation.",
    pills: ["Investor-Ready", "Financial Model", "Data Room", "M&A Support"],
    allPills: ["Investor-Ready Financials", "Financial Modelling", "Data Room Preparation", "M&A Due Diligence", "Debt & Equity Financing"],
    services: [
      { name: "Investor-Ready Financials", desc: "Clean books, consistent accounting policy and auditor coordination — the financial backbone every diligence process demands." },
      { name: "Financial Modelling for Fundraising", desc: "Bottoms-up revenue models, full three-statement builds and scenario analysis that stands up to investor scrutiny." },
      { name: "Data Room Preparation", desc: "Structured, populated, managed and indexed — 180+ documents organised before the first investor asks." },
      { name: "M&A and Due Diligence Support", desc: "Buy-side and sell-side support, quality-of-earnings analysis and working capital reviews." },
      { name: "Debt & Equity Financing Support", desc: "Bank presentations, debt service models and term sheet reviews — so you negotiate from strength." },
    ],
  },
  {
    num: "04",
    slug: "talent",
    title: "On-Demand Talent",
    headline: ["On-Demand", "Talent."],
    sub: "Senior finance professionals when you need them — fractional, interim, project-based or as augmentation for your existing team. No recruitment, no notice periods, no long-term commitment.",
    desc: "Senior finance professionals when you need them — fractional, interim, or project-based. No recruitment, no notice periods.",
    pills: ["Fractional CFO", "Interim Finance", "Controller", "Specialists"],
    allPills: ["Fractional CFO", "Interim Finance Lead", "Controller on Demand", "Project Specialists", "Team Augmentation"],
    services: [
      { name: "Fractional CFO", desc: "4–15 days a month of strategic leadership — board and investor management included." },
      { name: "Interim Finance Lead", desc: "Immediate availability, a full handover at the end, and continuity for your team in between." },
      { name: "Controller on Demand", desc: "Financial controls, audit readiness and a reporting structure that scales with you." },
      { name: "Project-Based Finance Specialists", desc: "ERP implementations, process redesign and cost-reduction programmes with a defined start and finish." },
      { name: "Finance Team Augmentation", desc: "Peak-period cover, audit season reinforcement and fundraise support — exactly when you need it." },
    ],
  },
];

export const OUTCOME_TABS = [
  {
    id: "d2c",
    label: "D2C Brand",
    metrics: [
      { label: "Net Revenue", value: "₹38.2L", delta: "+22% MoM", up: true },
      { label: "Gross Margin", value: "58.4%", delta: "+2.1pp vs last mo", up: true },
      { label: "CAC (blended)", value: "₹312", delta: "+₹28 vs Sept", up: false },
      { label: "Inventory days", value: "34 days", delta: "Target: <45", up: true },
    ],
    bars: { title: "Revenue by channel", items: [["Own website", 42], ["Quick commerce", 34], ["Marketplaces", 24]] },
    extra: { title: "Unit economics", items: [["Contribution margin", "31.2%"], ["ROAS", "3.8x"], ["Repeat purchase rate", "27%"]] },
  },
  {
    id: "mfg",
    label: "Manufacturing",
    metrics: [
      { label: "Revenue", value: "₹2.4Cr", delta: "+18% MoM", up: true },
      { label: "Cash", value: "₹68L", delta: "Runway: 14 mo", up: true },
      { label: "Burn", value: "₹4.8L", delta: "-12% vs plan", up: true },
      { label: "Outstanding AP", value: "₹2.1L", delta: "Books closed: Oct 5", up: true },
    ],
    bars: { title: "Monthly revenue — 9 months", items: [["Feb", 38], ["Mar", 42], ["Apr", 45], ["May", 51], ["Jun", 49], ["Jul", 58], ["Aug", 64], ["Sep", 72], ["Oct", 84]] },
    extra: { title: "At a glance", items: [["Gross Margin", "74.2%"], ["MoM Growth", "+18.4%"], ["Status", "Updated just now"]] },
  },
  {
    id: "saas",
    label: "Software & Services",
    metrics: [
      { label: "MRR", value: "₹24.6L", delta: "+12% MoM", up: true },
      { label: "ARR", value: "₹2.95Cr", delta: "Annualised", up: true },
      { label: "Churn", value: "1.8%", delta: "Target: <2%", up: true },
      { label: "Net Revenue Retention", value: "118%", delta: "Expanding base", up: true },
    ],
    bars: { title: "Revenue by segment", items: [["Enterprise", 52], ["SMB", 33], ["Self-serve", 15]] },
    extra: { title: "Health", items: [["Logo retention", "96%"], ["Payback period", "11 mo"], ["Pipeline coverage", "2.4x"]] },
  },
];

const thumb = (id) => `https://images.unsplash.com/${id}?auto=format&fit=crop&w=800&q=70`;

export const ARTICLES = [
  { slug: "parttime-cfo", author: "Ranjini Karthik", tag: "Part-Time CFO · Bengaluru", title: "Part-Time CFO in Bengaluru — What It Is, What It Costs, When You Need One.", excerpt: "A plain-language guide for founders who are outgrowing their current finance setup.", readTime: "8 min", image: thumb("photo-1577962917302-cd874c4e31d2") },
  { slug: "esop", author: "Madhurya Shankar", tag: "Equity · Strategy", title: "ESOPs as a strategic tool — not just a retention gimmick.", excerpt: "Most founders introduce ESOPs when they feel pressure to retain someone.", readTime: "6 min", image: thumb("photo-1681505531034-8d67054e07f6") },
  { slug: "rvpc", author: "Ranjini Karthik", tag: "Finance Fundamentals", title: "Revenue, profit and cash flow are not the same thing.", excerpt: "The three numbers every business tracks. The one number most businesses confuse.", readTime: "5 min", image: thumb("photo-1709880945165-d2208c6ad2ec") },
  { slug: "growth", author: "Madhurya Shankar", tag: "Growth · Strategy", title: "Growth solves all problems. Until it doesn't.", excerpt: "The most dangerous moment in a business is when growth is strong and the cracks are invisible.", readTime: "7 min", image: thumb("photo-1611974789855-9c2a0a7236a3") },
  { slug: "margin", author: "Ranjini Karthik", tag: "Finance Fundamentals", title: "Gross margin — the one number every founder must know.", excerpt: "It is not revenue. It is not profit. It is the number that tells you whether your business model works.", readTime: "6 min", image: thumb("photo-1648201637025-1c77b9be3013") },
  { slug: "cashflow", author: "Madhurya Shankar", tag: "Cash Management", title: "Why profitable businesses run out of cash.", excerpt: "It happens more often than you'd think. A business can show a healthy P&L and still find itself unable to meet payroll.", readTime: "5 min", image: thumb("photo-1565371767810-ef913a6c8315") },
  { slug: "cfo", author: "Ranjini Karthik", tag: "Leadership · Finance", title: "When does a founder stop being the de facto CFO?", excerpt: "There's a moment in every growing business when the founder realises they can't anymore.", readTime: "5 min", image: thumb("photo-1771244678811-50c22f17c791") },
  { slug: "d2c-metrics", author: "Madhurya Shankar", tag: "D2C · Unit Economics", title: "The D2C metrics that actually matter.", excerpt: "CM1, CM2, CM3, CAC, ROAS — and why revenue tells you almost nothing.", readTime: "10 min", image: thumb("photo-1770013413878-2530e2c3d82b") },
  { slug: "horeca", author: "Ranjini Karthik", tag: "HoReCa · Hospitality Finance", title: "HoReCa — what it is, why it matters, and how to measure success.", excerpt: "Hotels, restaurants, catering. One of India's fastest-growing sectors.", readTime: "9 min", image: thumb("photo-1761912915167-558fa68f16b7") },
];

export const RESOURCES = [
  {
    slug: "/resources/esop-toolkit",
    title: "ESOP Sutra Toolkit",
    kind: "Interactive toolkit",
    desc: "A plain-English walkthrough of how ESOPs work, what they cost, and what they're worth. Calculate vesting schedules, model dilution, and understand the tax implications — without a lawyer.",
    features: ["ESOP value calculator", "Vesting schedule builder", "Dilution modelling"],
    status: "Live · Free to use",
  },
  {
    slug: "/resources/cashflow-forecast",
    title: "13-Week Cash Flow Forecast",
    kind: "Working model & guide",
    desc: "The exact model CFOSutra builds for every client. Real Excel mockups, week-by-week breakdown, and a plain-language guide to reading and acting on the numbers.",
    features: ["Full 13-week tracker with real data", "AR aging schedule included", "Amber flags for cash crunch weeks"],
    status: "Live · Free to use",
  },
  {
    slug: "/resources/health-check",
    title: "Finance Function Health Check",
    kind: "Interactive self-assessment",
    desc: "10 questions every founder should be able to answer about their business. Instant score, question-by-question breakdown, and exactly what to fix first.",
    features: ["10-question interactive diagnostic", "Instant score out of 10", "Personalised fix for every gap"],
    status: "Live · 5 minutes",
  },
];

export const TIERS = [
  {
    name: "Starter Pack",
    price: "₹25,000/month",
    bestFor: "Solopreneurs, internet services, early-stage founders, consulting firms",
    features: [
      "Full bookkeeping and GL",
      "GST filing — all returns, on time",
      "TDS and statutory compliance",
      "Payroll processing and payslips",
      "Monthly P&L and balance sheet",
      "Books closed by the 5th",
      "One point of contact, same-day response",
    ],
  },
  {
    name: "Scale-Up Pack",
    price: "₹65,000/month",
    bestFor: "D2C brands, restaurants, SaaS, manufacturers, high transaction volume",
    features: [
      "Everything in Starter, plus:",
      "Controller-layer oversight and financial controls",
      "AR automation — aging reports, collections follow-up",
      "AP automation — vendor payments, reconciliation",
      "Monthly cash flow forecast (13-week rolling)",
      "Investor-ready financials and reporting pack",
      "KPI design and monthly tracking",
      "Channel-level P&L (D2C, multi-outlet)",
    ],
    highlight: true,
  },
  {
    name: "Part-Time CFO",
    price: "Custom",
    bestFor: "Funded startups, businesses above ₹1Cr/month, pre-fundraise companies",
    features: [
      "Everything in Scale-Up, plus:",
      "Dedicated fractional CFO (4–15 days/month)",
      "Annual operating plan and budgeting",
      "Board and investor presentation support",
      "Fundraise-ready financial model",
      "Scenario planning and runway modelling",
      "Monthly strategic finance review with founder",
      "Data room and due diligence support",
    ],
  },
];

export const PRICING_FAQS = [
  { q: "Is pricing really fixed at these tiers?", a: "They're starting points, not rigid boxes. If your business has unusual complexity — multiple entities, foreign transactions, heavy inventory — we reflect that in scope, and you know the number before we start." },
  { q: 'What does "custom" mean for the CFO tier?', a: "Typically ₹80,000–₹1,80,000 per month depending on engagement level — days per month, board involvement, and fundraise support. A short call is usually enough to pin it down." },
  { q: "Is there a minimum contract period?", a: "No. Monthly retainer, no lock-in. We keep clients by being useful, not by contract." },
  { q: "My revenue is low but transactions are high. Which tier?", a: "Revenue isn't the only variable — transaction volume and complexity matter more. A D2C brand at ₹15L/month often needs Scale-Up. Book a call and we'll tell you straight." },
  { q: "Does the Starter pack include GST and payroll?", a: "Yes. Both included from the first rupee. Filing on time is the baseline, not an add-on." },
  { q: "Can I start with Starter and move up?", a: "Absolutely — most clients do. And we'll tell you when you've outgrown a tier; you'll never have to guess." },
];

export const QUIZ = [
  { q: "What best describes your business?", options: ["D2C / Ecommerce / Retail", "Software / SaaS / AI", "Hospitality / Restaurant / Cafe", "Services / Consulting / Internet", "Manufacturing / Trading"] },
  { q: "What is your approximate monthly revenue?", options: ["Under ₹25L/month", "₹25L–₹1Cr/month", "Above ₹1Cr/month"] },
  { q: "What's your most pressing finance need right now?", options: ["Clean books and compliance", "Financial visibility and reporting", "Investor-ready and fundraise support", "Strategic finance partner"] },
  { q: "How big is your team?", options: ["Just me, or 1–5 people", "6–25 people", "25+ people"] },
];

export function recommendTier(answers) {
  const [biz, revenue, need] = answers;
  if (biz === 0) return 1;
  if (biz === 1) return 2;
  if (biz === 3) return revenue === 2 || need === 3 ? 2 : 0;
  if (need === 3 && revenue === 2) return 2;
  if (need === 2) return revenue === 0 ? 1 : 2;
  if (biz === 2 || biz === 4) return revenue === 0 ? 0 : 1;
  return revenue === 0 ? 0 : 1;
}

export const COMPLEXITY_NOTES = [
  { label: "High complexity", text: "D2C / Ecommerce — multi-channel reconciliation, high transaction volumes, returns." },
  { label: "Senior involvement needed", text: "SaaS / Software / AI — deferred revenue, investor-ready reporting, board packs." },
  { label: "Starter-friendly", text: "Internet services / Consulting — moderate to low complexity, invoice-based." },
];

export const HEALTH_QUESTIONS = [
  { q: "Do you know your gross margin, right now, without looking it up?", fix: "Build a one-page margin report — revenue, COGS, gross margin by product line — and review it monthly." },
  { q: "Can you say roughly where your cash position will be 8 weeks from now?", fix: "Start a 13-week rolling cash flow forecast. Update it weekly. Amber-flag any week below your safety buffer." },
  { q: "Were your books closed by the 5th of last month?", fix: "Set a hard close calendar: reconciliations by the 2nd, journals by the 3rd, reports out by the 5th." },
  { q: "Do you know your monthly burn and current runway?", fix: "Track burn weekly and tie it to a runway number in months. If you don't know it, everything else is guesswork." },
  { q: "Is every statutory filing — GST, TDS, PF, PT — up to date?", fix: "Put a compliance calendar in place with one owner. Missed filings compound into penalties and diligence red flags." },
  { q: "Do you know which customers or products are actually profitable?", fix: "Build customer/product-level P&L. Most businesses find 20% of revenue destroys margin." },
  { q: "Has payroll ever been delayed or been a last-minute scramble?", fix: "Automate payroll processing and ring-fence payroll cash at the start of every month." },
  { q: "Can you pull an AR aging report in under five minutes?", fix: "Set up weekly AR aging with follow-up owners per bucket. Cash stuck in receivables is a silent killer." },
  { q: "Can you read your P&L fluently and explain last month's movement?", fix: "Get a monthly commentary with your close — what changed, why, and what to watch next month." },
  { q: "Could you hand an investor a data room within two weeks?", fix: "Start assembling your data room now — financials, cap table, contracts, compliance — before you need it." },
];

export const LANDING_PAGES = {
  accounting: {
    slug: "accounting",
    eyebrow: "Accounting services for small business · Bengaluru",
    headline: ["Clean books. Clear numbers.", "No stress."],
    sub: "CFOSutra handles your accounting so you don't have to. Books closed by the 5th, GST filed on time, payroll processed without a fire drill — every single month.",
  },
  cfo: {
    slug: "cfo",
    eyebrow: "Part-time CFO services · Bengaluru",
    headline: ["CFO-level thinking. Without the", "full-time cost."],
    sub: "CFOSutra provides part-time CFO services for founder-run businesses in Bengaluru — planning, forecasting, board reporting and fundraise support on a monthly retainer.",
  },
  restaurant: {
    slug: "restaurant",
    eyebrow: "Accounting for restaurants & hospitality · Bengaluru",
    headline: ["Your restaurant numbers, finally making", "sense."],
    sub: "CFOSutra handles accounting, GST and payroll for restaurants, cafes and hospitality businesses in Bengaluru — outlet-level P&L, inventory discipline and clean compliance.",
  },
};
